module.exports = __webpack_public_path__ + "static/img/header-lightbox-forest.18f0b00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header-lightbox-forest.jpg
// module id = HRhn
// module chunks = 1